export const ControlRoutes = {
  Login: "login",
  ControlCenter: "control-center",
  Clients: "clients",
  AccountDetails: "accountDetails",
  Transactions: "transactions",
  SysOperator: "sysop",
  PasswordManagement: "passwordManagement",
};
